import { Popover, styled, Theme, Typography } from '@material-ui/core';

export const StyledPopover = styled(Popover)<Theme>(() => ({
  '& .MuiPopover-paper': {
    padding: '24px',
    borderRadius: 16,
  },
}));

export const StyledTypography = styled(Typography)<Theme>(() => ({
  lineHeight: '20px',
}));
